/* tslint:disable */
import {
  Patient
} from '../index';

declare var Object: any;
export interface PodcastActivityInterface {
  "type"?: string;
  "file"?: string;
  "createdAt"?: Date;
  "data"?: any;
  "id"?: any;
  "patientId"?: any;
  "created"?: Date;
  patient?: Patient;
}

export class PodcastActivity implements PodcastActivityInterface {
  "type": string;
  "file": string;
  "createdAt": Date;
  "data": any;
  "id": any;
  "patientId": any;
  "created": Date;
  patient: Patient;
  constructor(data?: PodcastActivityInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PodcastActivity`.
   */
  public static getModelName() {
    return "PodcastActivity";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PodcastActivity for dynamic purposes.
  **/
  public static factory(data: PodcastActivityInterface): PodcastActivity{
    return new PodcastActivity(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PodcastActivity',
      plural: 'PodcastActivities',
      path: 'PodcastActivities',
      idName: 'id',
      properties: {
        "type": {
          name: 'type',
          type: 'string'
        },
        "file": {
          name: 'file',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "data": {
          name: 'data',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "patientId": {
          name: 'patientId',
          type: 'any'
        },
        "created": {
          name: 'created',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        patient: {
          name: 'patient',
          type: 'Patient',
          model: 'Patient',
          relationType: 'belongsTo',
                  keyFrom: 'patientId',
          keyTo: 'id'
        },
      }
    }
  }
}
